import React from 'react'

export default ({width, height, color}) => {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" 
      width={`${width}px`} height={`${height}px`} viewBox="0 0 113.09 113.091" enableBackground="new 0 0 113.09 113.091">
      <circle fill="none" stroke={color} strokeWidth="7" strokeMiterlimit="10" cx="56.875" cy="56.546" r="50"/>
      <circle fill="none" stroke={color} strokeWidth="7" strokeMiterlimit="10" cx="47.032" cy="27.913" r="7.019"/>
      <polyline fill="none" stroke={color} strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
        4.536,102.67 44.203,36.336 44.203,86.133 71.536,36.336 71.536,86.133 101.203,36.336 "/>
    </svg>
  )
}